module.exports = __webpack_public_path__ + "media/assets/community/mobile-bar-cb9a2d0b8ac8c120ff2c5c4da3c9f6dd534318f0d2ddd8077f0fb2b3ef88ef31.png";